// extracted by css-extract-rspack-plugin
export default {"cls1":"Base-cls1_y04","cls2":"Base-cls2_NWm Base-cls1_y04","variant-default":"Base-variant-default_YVa","hoisted":"Base-hoisted_C-R","variant-dense":"Base-variant-dense_UYE"};